import React from 'react';
import PropTypes from 'prop-types';

const Body = ({ actionType, item, title, selectedCount }) => {
  if (actionType === 'mass') {
    switch (title) {
    case 'Suspend all':
      return (
        <>
          <div className="text-center">Are you sure you want to suspend</div>
          <div className="text-center">
            {' '}
            <b>{selectedCount}</b>
            {' '}
            selected users?
          </div>
        </>
      );
    case 'Activate all':
      return (
        <>
          <div className="text-center">Are you sure you want to activate</div>
          <div className="text-center">
            {' '}
            <b>{selectedCount}</b>
            {' '}
            selected users?
          </div>
        </>
      );
    case 'Delete custom rates':
      return (
        <div className="text-center">
          Are you sure you want to delete custom rates for
          {' '}
          <b>{selectedCount}</b>
          {' '}
          selected users?
        </div>
      );

    default:
      return '';
    }
  }

  if (actionType === 'single') {
    switch (title) {
    case 'Suspend user':
      return (
        <>
          <div className="text-center">Are you sure you want to suspend user</div>
          <div className="text-center">
            <b>{item.username}</b>
            ?
          </div>
        </>
      );
    case 'Activate user':
      return (
        <>
          <div className="text-center">Are you sure you want to activate user</div>
          <div className="text-center">
            <b>{item.username}</b>
            ?
          </div>
        </>
      );

    default:
      return '';
    }
  }

  return null;
};

Body.propTypes = {
  actionType: PropTypes.string,
  item: PropTypes.object,
  title: PropTypes.string,
  selectedCount: PropTypes.number,
};

export default Body;
